export default __webpack_public_path__ + "static/media/plain-sticker-ad.8790dbc1.png";